module.exports = __webpack_public_path__ + "46b14496cdac17676ba5a1ae5a98cccb.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-bold.woff
// module id = 73
// module chunks = 0